import React, { useState, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { MdClose } from "react-icons/md";
const MultipleFileDropzone = ({ setFieldValue, fieldName, prevImageWidth=125, prevImageHeight=125 }) => {
  const [files, setFiles] = useState([]);
  const onDrop = useCallback(
    (acceptedFiles) => {
      const newUniqueFiles = acceptedFiles.filter(
        (newFile) =>
          !files.some(
            (existingFile) =>
              existingFile.name === newFile.name &&
              existingFile.size === newFile.size
          )
      );
  
      const combined = [...files, ...newUniqueFiles];
  
      if (combined.length > 10) {
        alert("You can only upload up to 10 files.");
        return;
      }
  
      setFiles(combined);
      setFieldValue(fieldName, combined);
    },
    [files, setFieldValue, fieldName]
  );
  
  // Remove file by index
  const removeFile = (index) => {
    const newFiles = files.filter((_, i) => i !== index);
    setFiles(newFiles);
    setFieldValue(fieldName, newFiles);
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      "image/*": [],
      "video/*": []
    },
    multiple: true,
  });

  return (
    <div className="dropzone-container">
      <div {...getRootProps()} className="dropzone">
        <input {...getInputProps()} />
        <p>Drag & drop files here, or click to select files (Max: 10)</p>
      </div>
         
         {
          files.length > 0 && <div className="previewWrapper" > <div className="row"> 
               {
               files.map((file, index) => (<div className="col-md-2" key={index}>
                 <div className="previewBox" style={{width:prevImageWidth, height:prevImageHeight}}>
                      {file.type.startsWith("image/") ? (
                       
                <img src={URL.createObjectURL(file)} alt={file.name} />
               
              ) : (
                <p>{file.name}</p>
              )}
                <button type="button" className="remove-btn" onClick={() => removeFile(index)}>
                <MdClose />
              </button>
              </div>
               </div>))
              }
          </div> </div>
        }
         </div>
       
   
  );
};

export default MultipleFileDropzone;
